module.exports = __webpack_public_path__ + "static/media/magic-hat-icon.34d94ca1.svg";